import { IApplicationState } from '../types/redux';

export const sellersSelector = (state: IApplicationState) => {
  return state.newbuilding.sellers;
};

export function sellersWithPhonesSelector(state: IApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers.filter(seller => seller.showPhone && seller.phone);
  }

  return [];
}
